import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ENDPOINTS } from '../endpoints/api-endpoints';
import { SharedService } from './shared.service';
import { SESSION_STORAGE_KEYS, TENANT_DETAILS } from '../types/types';

@Injectable({
  providedIn: 'root'
})
export class SellerService {

  constructor(private http: HttpClient,private sharedService : SharedService) { }

  defaultTenantCompanyId = 22;
  defaultTenantFEUrl = 'https://smartsell.samhita.org/seller/login';
  BACK_END_URL = 'https://smarttsp.samhita.org/api';
  CAMPAIGN_BACK_END_URL = 'https://ondc-sdk.samhita.org/api';
  DA_BACK_END_URL = 'https://da.samhita.org/';
  AUS_BACK_END_URL = 'https://aus.samhita.org/';


  get TENANT_DETAILS() : TENANT_DETAILS{
    const tenantDetails = this.sharedService.getDataFromSessionStorage(SESSION_STORAGE_KEYS.TENANT_DETAILS,'SESSION') as TENANT_DETAILS
    return { BACK_END_URL : tenantDetails?.BACK_END_URL || this.BACK_END_URL , COMPANY_ID : tenantDetails?.COMPANY_ID || this.defaultTenantCompanyId , FE_URL : tenantDetails?.FE_URL || this.defaultTenantFEUrl}
  }

  sendOTP(phone: string) {
    return this.http.post(`${this.TENANT_DETAILS.BACK_END_URL}${ENDPOINTS.SELLER_SERVICE.SEND_OTP}`, { phone });
  }

  verifyOTP({ phone, otp ,company_id}: { phone: string; otp: string, company_id: number }) {
    return this.http.post(`${this.TENANT_DETAILS.BACK_END_URL}${ENDPOINTS.SELLER_SERVICE.VERIFY_OTP}`, { phone, otp, company_id : company_id.toString()});
  }

  getTheSellerInfo(phone: string) { 
    return this.http.post(`${this.TENANT_DETAILS.BACK_END_URL}${ENDPOINTS.SELLER_SERVICE.SELLER_INFO}`, {phone}).toPromise();
  }

  saveSellerInfo(data: any) {
    return this.http.post(`${this.TENANT_DETAILS.BACK_END_URL}${ENDPOINTS.SELLER_SERVICE.REGISTER_SELLER}`, data).toPromise();
  }

  simplefieldsSellerOnboarding(data: any) {
    return this.http.post(`${this.TENANT_DETAILS.BACK_END_URL}${ENDPOINTS.SELLER_SERVICE.SIMPLEFIELDS_SELLER_ONBOARDING}`, data)
  }

  getCountries(){
    return this.http.get(`${this.TENANT_DETAILS.BACK_END_URL}${ENDPOINTS.SELLER_SERVICE.COUNTRIES}`)
  }

  getStates(country_id:string){
    return this.http.post(`${this.TENANT_DETAILS.BACK_END_URL}${ENDPOINTS.SELLER_SERVICE.STATES}`,{ country_id })
  }

  checkPincodeServiceAvailability(pincode:string){
    return this.http.post(`${this.TENANT_DETAILS.BACK_END_URL}${ENDPOINTS.SELLER_SERVICE.CHECK_PINCODE_SERVICE_AVAILABILITY}`,{ pincode })
  }

  getCampaignData(campaignId:string){
    return this.http.get(`${this.CAMPAIGN_BACK_END_URL}${ENDPOINTS.CAMPAIGN_SERVICE.GET_CAMPAIGN_DATA}${campaignId}`)
  }

  updateCampaignTransaction(payload :{affiliate_id:string,status:"product_initiated" | "category_initiated",campaign_id:string,user_id:string},otherPayload:{product_or_category:"product" | "category", product_id_or_category_name:string}){
    const requestPayload = { ...payload , product_id : '' , category_name : '' };
    if(otherPayload?.product_or_category === "product"){
      requestPayload['product_id'] = otherPayload.product_id_or_category_name;
    }else if(otherPayload?.product_or_category === "category"){
      requestPayload['category_name'] = otherPayload.product_id_or_category_name;
    }
    return this.http.post(`${this.CAMPAIGN_BACK_END_URL}${ENDPOINTS.CAMPAIGN_SERVICE.UPDATE_TRANSACTION_STATUS}`,requestPayload)
  }

  getPartnerSamhithaId(samhitha_id:string){
    return this.http.get(`${this.DA_BACK_END_URL}${ENDPOINTS.DA_SERVICE.GET_PARTNER_SAMHITHA_ID}?samhita_id=${samhitha_id}`)
  }

  onboardSellerOnSamhita(data: { full_name: string, email: string, phone: string, partner_id: string }){
    return this.http.post(`${this.AUS_BACK_END_URL}${ENDPOINTS.AUS_SERVICE.ONBOARD_SELLER}`, data)
  }

  updateParticipantData(participant_id: string, data: any){
    return this.http.put(`${this.AUS_BACK_END_URL}${ENDPOINTS.AUS_SERVICE.ONBOARD_SELLER}${participant_id}`, data)
  }

  checkUserValidity(user_id:number){
    return this.http.post(`${this.TENANT_DETAILS.BACK_END_URL}${ENDPOINTS.SELLER_SERVICE.CHECK_USER_VALIDITY}`, {user_id})
  }

  sellerMappingToUser(data: { user_id: number, seller_ids: number[], company_id: number }){
    return this.http.post(`${this.TENANT_DETAILS.BACK_END_URL}${ENDPOINTS.SELLER_SERVICE.SELLER_MAPPING_TO_USER}`, data)
  }

  // Credit Survey API Methods
  getCreditSurvey() {
    return this.http.get(`${this.TENANT_DETAILS.BACK_END_URL}${ENDPOINTS.SELLER_SERVICE.CREDIT_QUESTIONS}`);
  }

  submitCreditSurvey(data: any) {
    return this.http.post(`${this.TENANT_DETAILS.BACK_END_URL}${ENDPOINTS.SELLER_SERVICE.CREDIT_SURVEY}`, data);
  }
}
